const config = {
    legalPerform: {
        'bigData-btn-search': '绩效管理,月度绩效管理,月度绩效,查询',
        'bigData-btn-export': '绩效管理,月度绩效管理,月度绩效,导出',
    },
    performRectify: {
        'bigData-btn-search': '绩效管理,月度绩效管理,绩效整改,查询',
        'bigData-btn-export': '绩效管理,月度绩效管理,绩效整改,导出',
    },
}
export default config
